import React, { ReactNode } from 'react';
import { Icon } from '@tcc/crate';

interface ZoneGenerationNoDataProps {
  action?: ReactNode;
  message: string;
}

const ZoneGenerationNoData = ({ action, message }: ZoneGenerationNoDataProps) => {
  return (
    <div className="no-data" data-test-id="zone-generation-no-data">
      <Icon glyph={Icon.set.PLANTING} />
      <span>{message}</span>
      {action}
    </div>
  );
};

export default ZoneGenerationNoData;
